
  // Import the functions you need from the SDKs you need
  import { initializeApp } from "https://www.gstatic.com/firebasejs/12.0.0/firebase-app.js";
  import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.0.0/firebase-analytics.js";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyCTYKADFHl72an2hEMIoWpkHXW7Zi370Ws",
    authDomain: "quantumleap-web.firebaseapp.com",
    projectId: "quantumleap-web",
    storageBucket: "quantumleap-web.firebasestorage.app",
    messagingSenderId: "29063915438",
    appId: "1:29063915438:web:7290002b46146c395a0a3f",
    measurementId: "G-228G4L57P8"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
